import { render, staticRenderFns } from "./BulkInviteModal.vue?vue&type=template&id=38cf5010&scoped=true"
import script from "./BulkInviteModal.vue?vue&type=script&lang=js"
export * from "./BulkInviteModal.vue?vue&type=script&lang=js"
import style0 from "./BulkInviteModal.vue?vue&type=style&index=0&id=38cf5010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf5010",
  null
  
)

export default component.exports